import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=70cf9bcd&scoped=true&lang=pug&"
import script from "./ProductGallery.vue?vue&type=script&lang=js&"
export * from "./ProductGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProductGallery.vue?vue&type=style&index=0&id=70cf9bcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cf9bcd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70cf9bcd')) {
      api.createRecord('70cf9bcd', component.options)
    } else {
      api.reload('70cf9bcd', component.options)
    }
    module.hot.accept("./ProductGallery.vue?vue&type=template&id=70cf9bcd&scoped=true&lang=pug&", function () {
      api.rerender('70cf9bcd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/bourdain/ProductGallery.vue"
export default component.exports